// импортируется через partial _CryptoModule.cshtml
// import "@httpmodule/lavanda_crypto";
// import "@httpmodule/lavanda_mod";
// import "@httpmodule/lavanda_npx";
// import "@httpmodule/lavanda";
// import "@httpmodule/signer_gui";
// import "@httpmodule/signer";
//
// import "@CryptoModule/formSigner";
// import "@CryptoModule/requestServer";
// import "@CryptoModule/CryptoModule.Initor";
// import "@CryptoModule/CryptoModule.DataForSignView";

import {
    Cancel,
    Lavanda,
    LavandaParams,
    Message,
    ParamsValues,
    SelectCertificateParams,
    SetLocale
} from '@keysystems/cryptomodule/source';

const CryptoModule = {
    Lavanda,
    LavandaParams,
    ParamsValues,
    SetLocale,
    SelectCertificateParams,
    Errors: {
        Message,
        Cancel
    },
};

window.KS = window.KS || {};
window.KS.CryptoModule = CryptoModule;
